<template>
    <div class="day-list">
        <div class="arrow left" :class="channelClass" @click="prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>
        <div class="days-cont">
            <div v-for="(day, index) in days" v-bind:key="index" class="day" :class="[channelClass, {selected: day.dateC == isSelected}]" @click="fetchSchedData(index)">
                <div class="name">{{ day.dateD.dayOTW }}</div>
                <div class="date">{{ day.dateD.dayN }}</div>
            </div>
        </div>
        <div class="arrow right" :class="channelClass" @click="next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>
    </div>
</template>

<script>
import lib from '@/lib'

export default {
    name: 'dayList',
    data() {
        return {
            x: 0,
            y: 7
        }
    },
    computed: {
        days() {
            let x = (this.$store.state.week * 7)
            let y = (this.$store.state.week * 7) + 7
            return Array.isArray(this.$store.state.days) ? this.$store.state.days.slice(x, y) : []
        },
        isSelected() {
            return this.$store.state.days[(this.$store.state.selectedDay) + (this.$store.state.week * 7)].dateC
        },
        channelClass() {
            return this.$store.state.channel
        }
    },
    methods: {
        fetchSchedData(i) {
            this.$store.commit('selectDay', i)
            lib.fetchSchedData(this.$store.state.channel, this.$store.state.days[(this.$store.state.selectedDay) + (this.$store.state.week * 7)].dateA)
        },
        next() {
            this.$store.commit('incWeek')
            lib.fetchSchedData(this.$store.state.channel, this.$store.state.days[(this.$store.state.selectedDay) + (this.$store.state.week * 7)].dateA)
        },
        prev() {
            this.$store.commit('decWeek')
            lib.fetchSchedData(this.$store.state.channel, this.$store.state.days[(this.$store.state.selectedDay) + (this.$store.state.week * 7)].dateA)
        }
    },
    updated() {

        let x = document.getElementsByClassName('selected')[0]

        // x.scrollIntoViewIfNeeded()
    }
}
</script>





// WEBPACK FOOTER //
// src/components/day-list.vue